import { Quaternion } from '@babylonjs/core/Maths/math.vector';
import type { SolidParticle } from '@babylonjs/core/Particles/solidParticle';

import { CircularPatternFeature } from '@kb3d/models/classes/features/circular-pattern-feature';
import type { SubmeshVertexData } from '@kb3d/view/helpers/geometry-helper';
import { ProcessorData } from './base-processor';
import { PatternGeometryProcessor } from './pattern-geometry';

export class CircularPatternGeometryProcessor extends PatternGeometryProcessor<CircularPatternFeature> {
    updateMeshGeometry(
        feature: CircularPatternFeature,
        vertexData: SubmeshVertexData,
        vertexDataChanges: Partial<SubmeshVertexData>,
        dependencyData: ProcessorData<never>
    ) {
        const featurePivot = feature.pivot.toVec3();
        const featureAxis = feature.axis.toVec3();
        // Don't allow a zero vector for an axis because it will blow up the math
        if (featureAxis.equalsToFloats(0, 0, 0)) {
            featureAxis.set(0, 1, 0);
        }

        const totalArc = (feature.arc * Math.PI) / 180;
        // if the full circle (360°), distribute evenly around the circle
        // otherwise, include both ends of the arc range
        const stepArc = feature.count > 1 ? totalArc / (feature.arc >= 360 ? feature.count : feature.count - 1) : 0;
        const workingQuaternion = Quaternion.Identity();

        return super.updateMeshGeometry(
            feature,
            vertexData,
            vertexDataChanges,
            dependencyData,
            (idx: number, particle: SolidParticle) => {
                particle.pivot = featurePivot;
                Quaternion.RotationAxisToRef(featureAxis, stepArc * idx, workingQuaternion);
                particle.rotationQuaternion!.multiplyInPlace(workingQuaternion);
            }
        );
    }
}
